export default __webpack_public_path__ + "static/media/change.6a263d84.svg";